import { OrgInterface } from '../Org/Org.Interface';
import { GroupInterface } from '../Groups/Group.Interface';
import { LocationInterface } from '../Locations/Location.Interface';
import { LocationVarKey } from './Generated/LocationVarKey.Data';


export interface LocationVarInterface {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  orgId: number;
  org: OrgInterface;
  key: string;
  value: string;
  groupId?: number;
  group?: GroupInterface;
  locationId?: number;
  location?: LocationInterface;
}

export enum LocationVarInheritance {
  NONE = 'none',
  GROUP = 'group',
  ORG = 'org',
  DEFAULT = 'default',
}
export interface LocationVarWithId {
  id: number;
  key: string;
  value: string;
}
export interface MergedLocationVar  {
  id?: number;
  key: string;
  value: string;
  inheritance: LocationVarInheritance;
}
export type MergedLocationVars = { [key in LocationVarKey]?: MergedLocationVar };
export type MergedVarsWithKeys<T extends LocationVarKey> = { [key in T]: MergedLocationVar };
export type LocationVarsById = { [id in number]?: LocationVarInterface };
export type LocationVarsWithIdByKey = { [key in LocationVarKey]?: LocationVarWithId };
export type LocationVarsWithIdByKeyByGroupOrLocationId =  { [groupOrLocationId: number]:{ [key in LocationVarKey]?: LocationVarWithId }};

export enum LimitToLocationType {
  GROUP = 'group',
  LOCATION = 'location',
  ORG = 'org',
}

export const PostProcessLocationVars = [
  LocationVarKey.Name
] 


